import type { StatoGiocatore, StatoSportivo } from '@calcio/shared';

/**
 * Colori fissi, gli stessi in ogni tema (`--stato-*` e `--cartellino-*` in
 * `src/index.css`): con fondo e testo propri il badge si legge su qualunque
 * sfondo. Il disponibile e il regolare, verdi, li colorano solo le tendine
 * della scheda.
 */
export const COLORE_STATO: Record<StatoGiocatore, string> = {
  disponibile: 'bg-stato-disponibile text-white',
  affaticato: 'bg-stato-affaticato text-black',
  recupero: 'bg-stato-recupero text-black',
  infortunato: 'bg-stato-infortunato text-white',
};

export const COLORE_SPORTIVO: Record<StatoSportivo | 'regolare', string> = {
  regolare: 'bg-stato-disponibile text-white',
  diffidato: 'bg-cartellino-giallo text-black',
  squalificato: 'bg-cartellino-rosso text-white',
};

/**
 * Fascia di un valore d'attributo (1-100), con gli stessi colori fissi degli
 * stati: rosso sotto 40, arancio fino a 59, giallo fino a 79, verde da 80.
 */
export function coloreValore(valore: number): string {
  if (valore >= 80) return 'bg-stato-disponibile text-white';
  if (valore >= 60) return 'bg-stato-affaticato text-black';
  if (valore >= 40) return 'bg-stato-recupero text-black';
  return 'bg-stato-infortunato text-white';
}

/**
 * Fascia di un voto (1-10 a mezzi punti), con gli stessi colori: rosso sotto
 * il 5, arancio fino al 5,5, giallo fino al 6,5, verde dal 7.
 */
export function coloreVoto(voto: number): string {
  if (voto >= 7) return 'bg-stato-disponibile text-white';
  if (voto >= 6) return 'bg-stato-affaticato text-black';
  if (voto >= 5) return 'bg-stato-recupero text-black';
  return 'bg-stato-infortunato text-white';
}

/** La stessa fascia di `coloreValore`, per il tratto di un anello. */
export function trattoValore(valore: number): string {
  if (valore >= 80) return 'stroke-stato-disponibile';
  if (valore >= 60) return 'stroke-stato-affaticato';
  if (valore >= 40) return 'stroke-stato-recupero';
  return 'stroke-stato-infortunato';
}
